import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { APP_CONFIG } from '../shared/injectionTokens';
import { BobHttpService } from '../shared/services/bob-http.service';
import { SiteOID } from '../site-detail/models/Site';

import { Favorite, FavoriteOID, RESOURCE_TYPE } from './models/favorite';

const FAVORITES_ENDPOINT = '/favorite-api/public/v1';

@Injectable({ providedIn: 'root' })
export class FavoritesGateway {
    private readonly http = inject(BobHttpService);
    private readonly applicationOID = inject(APP_CONFIG).bobApi.favoriteApplicationOID;

    async getFavorites(): Promise<Favorite[]> {
        const response = await firstValueFrom<{ results: Favorite[] }>(
            this.http.get(`${FAVORITES_ENDPOINT}/applications/${this.applicationOID}/favorites`),
        );
        return response.results;
    }

    add(siteOID: SiteOID): Promise<Favorite> {
        return firstValueFrom(
            this.http.post(`${FAVORITES_ENDPOINT}/applications/${this.applicationOID}/favorites`, {
                resourceType: RESOURCE_TYPE.SITE,
                resourceOID: siteOID,
                metadata: {},
            }),
        );
    }

    async remove(favoriteOID: FavoriteOID): Promise<void> {
        await firstValueFrom(this.http.delete(`${FAVORITES_ENDPOINT}/favorites/${favoriteOID}`));
    }
}
